export enum ExactResponseMessageTypes {
    CustomWarning = 'CustomWarning',
    Error = '0',
    FatalError = '3',
    Success = '2',
    Warning = '1',
}
